import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

import {
  Container,
  Description,
  DescriptionBold,
  Image,
  Title,
} from './section-infos'

interface ContainerRootProps extends ComponentProps<'div'> {}

function ContainerRoot({ className, ...rest }: ContainerRootProps) {
  return (
    <div className={twMerge('relative h-150', className)} {...rest} />
  )
}

export { ContainerRoot, Description, Container, Image, Title, DescriptionBold }
